import React from 'react';
import PropTypes from 'prop-types';
import { Redirect } from 'react-router-dom';
import { useSelector } from 'react-redux';
import Loader from '../../../components/Loader/Loader';

const Protected = ({ children }) => {
  const loggedIn = useSelector(state => !!state.auth.user);
  const isLoading = useSelector(({ auth, affiliate }) => !auth.loaded || (!!auth.user && !affiliate.loaded));

  /*  if (errorLoader && error?.status === 401) {
    return <Redirect to="/login" />;
  } */
  if (isLoading) {
    return <Loader />;
  }
  if (!loggedIn) {
    return <Redirect to="login" />;
  }
  return <>{children}</>;
};

Protected.propTypes = {
  children: PropTypes.node,
};

Protected.defaultProps = {
  children: null,
};

export default Protected;
